import { render, staticRenderFns } from "./backoffice-header.vue?vue&type=template&id=5c978c61&"
import script from "./backoffice-header.vue?vue&type=script&lang=js&"
export * from "./backoffice-header.vue?vue&type=script&lang=js&"
import style0 from "./backoffice-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports